<template>
  <DialogFrame v-if="isOpen" @click-background="close">
    <button class="close" @click="close">×</button>
    <div class="logout-content" style="flex-direction: column; align-items: center; justify-content: center">
      <div
        v-if="$root.account.isLogin"
      >
        <div style="padding-bottom: 6px;color: #333;">
          {{ $root.account.info.userName }}としてログイン中です。
        </div>
        <h4 class="title">ログアウトしますか？</h4>
        <!--/*  action="/logout"  */-->
        <div style="display:flex;" role="form">
          <button id="focusOnOpen" class="btn btn-primary" style="margin-left: auto;margin-right: 10px;" @click="logout">
            <span>ログアウト</span>
          </button>
          <button
            class="btn btn-outline-primary"
            style="margin-right: auto;width: initial;"
            @click="close"
          >
            <span>キャンセル</span>
          </button>
        </div>
      </div>
      <div v-else>
        <h5 class="title" style="margin:20px 40px 6px;word-break: keep-all;">ログインしていません。</h5>
        <button id="focusOnOpen" class="btn btn-primary" style="margin:1rem 2rem" @click="close">
          <span>閉じる</span>
        </button>
      </div>
    </div>
  </DialogFrame>
</template>

<style lang="scss" scoped>
.title{
  padding-bottom: 20px;
  font-size: 1.3rem;
}
.logout-content{
  text-align:center;
  padding: 40px 8px 30px;
  width: 70vw;
  max-width: 600px;
  
  @media (max-width: 768px) {
    width: 80vw;
  }
  @media (max-width: 576px) {
    width: 85vw;
  }
  @media (max-width: 480px) {
    width: 90vw;
  }
}
</style>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import DialogFrame from "./DialogFrame.vue";

@Options({ components: { DialogFrame } })
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  isOpen: boolean = false;

  open() {
    this.isOpen = true;
    this.$root.focus("focusOnOpen")
  }
  close() {
    this.isOpen = false;
  }

  logout() {
    this.$root.restAccess
      .postLogout()
      .then(() => {
        this.$root.account.clear();
        this.$root.nortifyAccountChangeToBrowserTabs();
        this.close();
        this.movePage();
      })
      .catch((e) => {
        if (process.env.VUE_APP_MODE === "development") {
          console.log("ログアウトに失敗しました", e);
        }
      });
  }

  movePage() {
    //ログアウト時は画面遷移する
    //（ゲームをしてて、ログアウト後もサーバー保存処理等が継続できてしまうため。保存処理はページに残されたログアウト前のユーザ情報でするので無害ではある）
    if(
        this.$router.currentRoute.value.meta?.requiresAuth
        || (
            !this.$router.currentRoute.value.path.startsWith("/search")
          &&!this.$router.currentRoute.value.path.startsWith("/about")
        )
      ){
      this.$router.push("/");
    }
  }
}
</script>
